import React from 'react';
function NotLoggedIn() {
    return (  
        <div>Login to like,comment and share</div>
    );
}

export default NotLoggedIn;